<template>
  <div>
    <anchor-router-menu :items="menus.home" :user="user" />
    <anchor-sidebar-divider />
    <anchor-router-menu :items="menus.settings" :user="user" />
    <anchor-sidebar-divider />
    <v-list-item
      :href="`mailto:${systemEmail}`"
      :id="getItemId({ label: 'contact' }, 'li-anchor')"
    >
      <v-list-item-icon>
        <v-icon>mdi-help-circle</v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        Contact Us
      </v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
export default {
  props: {
    expanded: Boolean,
    hovering: Boolean,
  },
  computed: {
    user: vm => vm.$store.getters.user,
  },
  data: vm => ({
    menus: {
      home: [
        {
          text: 'Anchor Apps',
          icon: 'mdi-home',
          route: { name: 'HomeView' },
        },
      ],
      settings: [
        {
          text: 'Settings',
          icon: 'mdi-cog',
          items: [
            {
              text: 'Account Settings',
              route: { name: 'AdminAccountSettingsView' },
            },
            {
              text: 'Administration Controls',
              route: { name: 'AdminBaseControlView', query: { type: 'users' } },
            },
            {
              text: 'Group Administration',
              permission: vm.$permissions.VIEW_ORIGINATOR_GROUPS,
              route: { name: 'AdminGroupsView' },
            },
          ],
        },
      ],
    },
    systemEmail: 'systemrequests@anchorloans.com',
  }),
  methods: {
    getItemId: (item, prefix) => `${prefix}-${item.label.toLowerCase().split(' ').join('-')}`,
  },
};
</script>
